import React, { useState } from 'react';
import PasswordReset from './PasswordReset'; // Import the PasswordReset component
import { BASE_URL } from '../../Globalapi/Globalapi';

const ForgotPass = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [token, setToken] = useState('');

  // Save OTP to localStorage
  const storeOtpLocally = (otp) => {
    localStorage.setItem('otp', otp); // Store OTP
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    const response = await fetch(`${BASE_URL}/password/request_reset_password.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const rawText = await response.text();
    console.log('Raw response:', rawText);

    if (!response.ok) {
      setMessage(`HTTP error! status: ${response.status}`);
      setIsLoading(false);
      return;
    }

    try {
      const data = JSON.parse(rawText);
      console.log('Parsed response data:', data);

      if (data.success) {
        setMessage('OTP has been sent to your email.');
        setIsOtpSent(true);
      } else {
        setMessage(data.message || 'Error occurred while sending the OTP.');
      }
    } catch (error) {
      console.error('JSON parsing error:', error);
      setMessage('Received an unexpected response format.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      // Store OTP entered by user to localStorage
      storeOtpLocally(otp);

      const response = await fetch(`${BASE_URL}/password/verify_token.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: otp }),
      });
      console.log(response);
      
      const data = await response.json(); // Parse response as JSON
      console.log('Full OTP verification response:', data); // Log the full response object

      if (data.success) {
        console.log('Token received:', data.token); // Log token if received correctly
        setMessage('OTP verified successfully.You can now reset your password.');
        setToken(data.token); // Save the token for password reset
        localStorage.setItem('otp', otp); // Store token in localStorage
        setIsOtpVerified(true); // Set OTP verified state to true
      } else {
        setMessage('Invalid OTP, please try again.');
        localStorage.setItem('otp', data.token); // Store token in localStorage
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setMessage('An error occurred while verifying the OTP.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Conditionally render the title based on OTP sent/verification state */}
      {!isOtpSent && !isOtpVerified && <h2 style={styles.heading}>Forgot Password</h2>}
      {isOtpSent && !isOtpVerified && <h2 style={styles.heading}>OTP Verification</h2>}
      
      {message && <p style={styles.message}>{message}</p>}
      
      {/* Conditionally render the instruction */}
      {!isOtpVerified && (
        <p style={styles.instruction}>
          {!isOtpSent ? 'Please enter your email to receive a password reset link.' : 'Enter the OTP sent to your email.'}
        </p>
      )}

      {!isOtpSent && !isOtpVerified && (
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            style={styles.input}
            disabled={isLoading}
          />
          <button type="submit" style={styles.button} disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send OTP'}
          </button>
        </form>
      )}

      {isOtpSent && !isOtpVerified && (
        <form onSubmit={handleOtpSubmit} style={styles.form}>
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            required
            style={styles.input}
            disabled={isLoading}
          />
          <button type="submit" style={styles.button} disabled={isLoading}>
            {isLoading ? 'Verifying...' : 'Verify OTP'}
          </button>
        </form>
      )}

      {isOtpVerified && (
        <div>
          {console.log('Token being passed to PasswordReset:', token)} {/* Debugging log */}
          <PasswordReset token={token} />
        </div>
      )}
    </div>
  );
};

// CSS-in-JS styles
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  },
  heading: {
    fontSize: '24px',
    marginBottom: '10px',
    color: '#333',
  },
  instruction: {
    fontSize: '16px',
    marginBottom: '20px',
    color: '#555',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '400px',
  },
  input: {
    padding: '12px',
    fontSize: '16px',
    marginBottom: '20px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    width: '100%',
    boxSizing: 'border-box',
  },
  button: {
    padding: '12px',
    fontSize: '16px',
    backgroundColor: 'teal',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  message: {
    fontSize: '16px',
    color: 'red',
    marginBottom: '20px',
  },
};

export default ForgotPass;
